<template>
  <div class="div-dropdown-component">
    <single-select
      class="form"
      :options="optionsActivationReason"
      :value.sync="availabilityReason"
      :value-property="'value'"
      :disabled="readonly"
    />
    <span class="text-danger" v-if="modelstate['AvailabilityReason']">
      {{ "*" + modelstate["AvailabilityReason"][0] }}
    </span>
  </div>
</template>

<script>
export default {
  name: "vehicleAvailableReasonOptions",
  components: {
    "single-select": () => import("@/components_rms/base/SingleSelect.vue"),
  },
  props: {
    modelstate: Object,
    availabilityReason: Number,
  },
  data() {
    return {
      readonly: false,
      optionsActivationReason: [
        { value: 1, text: "Desativação" },
        { value: 2, text: "Ativação" },
      ],
    };
  },
  watch: {
    availabilityReason: {
      handler(newValue) {
        this.$emit("update:availabilityReason", newValue);
      },
      immediate: true,
    },
  },
};
</script>